import { isEmpty } from 'lodash';
import { setResult } from './resultActions';
import CLPLServiceClient from '../clients/CLPLServiceClient';
import selectors from '../../rootSelectors';
import { CLPL, ASSESSMENT_MODALITY } from '../../constants/measure';
import { makeApiGetRequest, makeApiPostRequest } from './apiActions';

export const saveResultResponse = postBody => dispatch => {
    const endpoint = CLPLServiceClient.constructSaveResultEnpoint();
    return dispatch(makeApiPostRequest(endpoint, postBody)).then(resultJson =>
        dispatch(setResult(resultJson)),
    );
};

export const saveMeasureResponse = (formId, resultResponse) => async (dispatch, getStore) => {
    const state = getStore();
    const instId = selectors.getInstId(state, CLPL.MEASURE);
    const postBody = {
        assessment: CLPL.ASSESSMENT,
        data_source: ASSESSMENT_MODALITY.ONLINE,
        inst_uid: instId,
        student_uid: selectors.getUserId(state),
        student_temporal_id: selectors.getStudentTemporalId(state, instId) || undefined, // unset if not available
        school_year: selectors.getSchoolYear(state),
        grade_level: selectors.getGrade(state),
        period: selectors.getToy(state),
        measure: CLPL.MEASURE,
        form_id: formId,
        responses: resultResponse,
    };
    return dispatch(saveResultResponse(postBody));
};

export const getStudentResults = () => (dispatch, getStore) => {
    const state = getStore();
    const studentId = selectors.getUserId(state);
    const grade = selectors.getGrade(state);
    const period = selectors.getToy(state);
    const schoolYear = selectors.getSchoolYear(state);
    const config = {
        studentId,
        grade,
        period,
        schoolYear,
    };
    const endpoint = CLPLServiceClient.constructResultListEndpoint(config);
    return dispatch(makeApiGetRequest(endpoint)).then(data => {
        const resultsData = isEmpty(data) ? [] : data;
        resultsData.forEach(resultData => {
            dispatch(setResult(resultData));
        });
    });
};
